import { alpha, inputBaseClasses, outlinedInputClasses, styled } from '@mui/material';
import { Field, FieldProps } from 'formik';
import { MuiOtpInput, MuiOtpInputProps } from 'mui-one-time-password-input';
import { FC } from 'react';

const StyledOtpInput = styled(MuiOtpInput)(({ theme }) => ({
    [`.${inputBaseClasses.input}`]: {
        width: 58,
        height: 58,
        boxSizing: 'border-box',
        color: theme.palette.text.primary,
        borderColor: theme.palette.text.secondary,
    },
    [`.${outlinedInputClasses.notchedOutline}`]: {
        borderColor: alpha(theme.palette.text.secondary, 0.3),
    },
    [`.${inputBaseClasses.root}:not(.Mui-focused):hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.palette.text.secondary,
    },
}));

interface FormOtpCodeFieldProps extends Partial<MuiOtpInputProps> {
    name: string;
    validate?: (value: string) => string | undefined;
}

export const FormOtpCodeField: FC<FormOtpCodeFieldProps> = ({
    name,
    length = 6,
    autoFocus = true,
    validateChar,
    validate,
    ...rest
}) => {
    return (
        <Field name={name} validate={validate}>
            {({ field, form: { setFieldValue, setFieldTouched } }: FieldProps) => {
                return (
                    <StyledOtpInput
                        gap={1.25}
                        {...field}
                        {...rest}
                        value={field.value || ''}
                        length={length}
                        autoFocus={autoFocus}
                        validateChar={validateChar}
                        onChange={(value: string) => {
                            setFieldValue(name, value);
                        }}
                        onBlur={() => setFieldTouched(name, true)}
                    />
                );
            }}
        </Field>
    );
};
